import React, { useEffect } from 'react';
import { DynamicForm } from 'modules/account/components/DynamicForm/DynamicForm';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { HelpBox } from '../../../components/HelpBox/HelpBox';
import { USER_DATA_KEY } from '../../../constantes/LocalStorageEnum';
import { useFormInitialValues } from '../../../hooks/useFormInitialValues';

const Contact: React.FC = () => {
  const theme = ApiLocalStorage.get('theme') || {};
  const showHelpBox = theme?.contact?.['show-contact-helpbox-fml'] !== false;
  
  const userData = ApiLocalStorage.get(USER_DATA_KEY);
  const initialValues = useFormInitialValues('contact', userData);
  
  // Debug temporário
  useEffect(() => {
    console.log('=== DEBUG CONTACT ===');
    console.log('userData:', userData);
    console.log('initialValues:', initialValues);
    console.log('Campos esperados: email, phoneNumber');
    console.log('Email value:', initialValues?.email);
    console.log('Phone value:', initialValues?.phoneNumber);
    console.log('===================');
  }, [userData, initialValues]);
  
  return (
    <>
      <DynamicForm
        pageName="contact"
        initialValues={initialValues}
      >
        {showHelpBox && <HelpBox/>}
      </DynamicForm>
    </>
  );
};

export default Contact;
